<template>
  <div class="w-full h-full m-4 p-0">
    <el-container style="border: 1px solid #eee;height: calc(100% - 20px);">
      <el-aside class="overflow-auto" width="250px" style="background-color: rgb(238, 241, 246);">
        <el-tabs v-model="activeName" type="border-card" class="h-full" stretch @tab-click="handleClick">
          <el-tab-pane label="部门" name="department">
            <div class="menu-type">成员</div>
            <el-menu @select="handleAllMemberSelect">
              <el-menu-item>全部成员</el-menu-item>
            </el-menu>
            <div class="menu-type">部门</div>
            <el-tree
              :default-expanded-keys="formatDepartments.length > 0 ? [formatDepartments[0].id] : []"
              draggable highlight-current class="dept_tree" node-key="id" :data="formatDepartments"
              :expand-on-click-node="false" @node-click="handleDepartmentSelect"
            >
              <span slot-scope="{ node, data }" class="group w-full">

                <el-popover
                  v-model="data.visible"
                  placement="bottom"
                  width="230"
                  height="160"
                  trigger="manual"
                >
                  <el-form
                    :ref="`editDeptForm_`+data.id" :model="editDeptForm" :rules="addDeptFormRules"
                  >
                    <el-form-item prop="name">
                      <el-input v-model="editDeptForm.name" placeholder="请输入部门名称" />
                    </el-form-item>
                    <el-form-item class="flex justify-between !mb-0">
                      <el-button @click="data.visible = false">取消</el-button>
                      <el-button type="primary" @click="handldEditDeptSubmit('editDeptForm_'+data.id, data)">确定</el-button>
                    </el-form-item>
                  </el-form>
                  <span slot="reference">

                    {{ data.name }}

                  </span>
                </el-popover>

                <span
                  class="invisible group-hover:visible"
                  @click.stop
                >
                  <el-dropdown trigger="click" @command="handleDeptMoreMenuSelect">
                    <span class="el-dropdown-link">
                      <i style="color: #0db3a6;" class="el-icon-more" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{action: 'edit', dept: data}">
                        <span>修改名称</span>
                      </el-dropdown-item>
                      <el-dropdown-item :command="{action: 'add', dept: data}">
                        <span>添加子部门</span>
                      </el-dropdown-item>
                      <el-dropdown-item class="!text-red-400" :command="{action: 'delete', dept: data}">删除
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>

              </span>
            </el-tree>
          </el-tab-pane>
          <el-tab-pane label="角色" name="role">
            <div class="flex justify-between items-center text-sm text-gray-400">
              <div>创建的角色</div>
              <div>
                <el-button type="text" icon="el-icon-plus" @click="handleAddRole" />
              </div>
            </div>
            <el-menu v-if="role_lists.length > 0" @select="handleSelect">
              <draggable :list="role_lists" handle=".handle" @end="handleMoveEnd">
                <div v-for="(role,index) in role_lists" :key="role.id">
                  <el-popover
                    v-model="role.visible"
                    placement="right-start"
                    :popper-options="{ destroyOnClose: true }"
                    width="230"
                    height="160"
                    trigger="manual"
                  >
                    <el-form
                      ref="editRoleForm" :model="editRoleForm" :rules="addRoleFormRules"
                    >
                      <el-form-item prop="name">
                        <el-input v-model="editRoleForm.name" placeholder="请输入角色名称" />
                      </el-form-item>
                      <el-form-item class="flex justify-between !mb-0">
                        <el-button @click="role.visible = false">取消</el-button>
                        <el-button type="primary" @click="handldEditRoleSubmit('editRoleForm', index)">确定</el-button>
                      </el-form-item>
                    </el-form>
                    <el-menu-item slot="reference" class="!pr-0" :index="role.id.toString()">
                      <div class="group flex">
                        <div class="text-clip !basis-3/4 overflow-hidden">{{ role.name }}</div>

                        <div
                          class="!basis-1/4 invisible group-hover:visible role-btn"
                          @click.stop
                        >
                          <el-button class="handle" type="text" icon="el-icon-rank" />
                          <el-dropdown trigger="click" @command="handleMoreMenuSelect">
                            <span class="el-dropdown-link">
                              <i class="el-icon-more" />
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="{action: 'edit', role: role}">
                                <span>修改名称</span>
                              </el-dropdown-item>
                              <el-dropdown-item class="!text-red-400" :command="{action: 'delete', role: role}">
                                删除
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                    </el-menu-item>
                  </el-popover>
                </div>
              </draggable>
            </el-menu>
            <el-empty v-else image-size="0" />
          </el-tab-pane>
        </el-tabs>
      </el-aside>

      <el-container class="flex flex-col member">
        <el-header height="40px">
          <span>{{ name }}</span>
        </el-header>

        <el-main class="right-content">
          <el-row class="pb-4" type="flex" justify="space-between">
            <el-col v-if="listMemberQuery.type === 'role'" :span="18">
              <el-button size="small" type="primary" @click="handleAddRoleMember">添加成员</el-button>
              <el-button size="small" @click="handleRemoveRoleMember">移出</el-button>
            </el-col>
            <el-col v-else :span="18">
              <el-button size="small" type="primary" @click="handleInviteUser">邀请成员</el-button>
              <el-button size="small" @click="openAdjustDialog">调整部门</el-button>
            </el-col>
            <el-col :span="6" />
          </el-row>
          <el-table :data="tableData" class="overflow-auto" @cell-click="onCellClick" @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55"
            />
            <el-table-column prop="username" label="用户名" width="140" />
            <el-table-column prop="nickname" label="姓名" width="120" />
            <el-table-column v-if="listMemberQuery.type === 'department' && listMemberQuery.department_id > 0" label="部门主管" width="120" @click.stop>
              <template slot-scope="scope">
                <el-switch v-model="scope.row.is_admin" @change="onAdminSwitch($event, scope.row.id)" @click.native.stop />
              </template>
            </el-table-column>
            <el-table-column prop="departments" label="部门" />
            <el-table-column v-if="listMemberQuery.type !== 'role'" prop="roles" label="角色" />
          </el-table>
          <el-pagination
            :current-page="listMemberQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listMemberQuery.per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-main>
      </el-container>
    </el-container>
    <el-dialog :visible.sync="addRoleDialogVisible" title="创建角色" width="40%" :close-on-click-modal="false">
      <el-form ref="addRoleForm" :model="addRoleForm" :rules="addRoleFormRules" label-width="80px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="addRoleForm.name" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddRoleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="addDeptDialogVisible" title="添加部门" width="40%" :close-on-click-modal="false">
      <el-form ref="addDeptForm" :model="addDeptForm" :rules="addDeptFormRules" label-width="80px">
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="addDeptForm.name" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDeptDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddDeptSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="pub_dialog" :visible.sync="addUserDialogVisible" title="成员列表" width="60%" :close-on-click-modal="false">
      <member-list v-if="addUserDialogVisible" v-model="selectedMember" :tabs="['user']" @cancel="addUserDialogVisible=false" @input="handleAddRoleMemberSubmit" />
    </el-dialog>
    <el-dialog :visible.sync="inviteUserDialogVisible" title="邀请成员" width="60%" :close-on-click-modal="false">
      <el-form ref="inviteForm" :model="inviteForm" :rules="inviteFormRules" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="inviteForm.username" />
        </el-form-item>
        <el-form-item label="姓名" prop="nickname">
          <el-input v-model="inviteForm.nickname" />
        </el-form-item>
        <el-form-item label="初始密码" prop="password">
          <el-input v-model="inviteForm.password" :type="showPassword ? '' : 'password'" autocomplete="new-password">
            <i
              slot="suffix" :class="[{'text-black': showPassword}, 'el-icon-view']" @click="togglePasswordStyle"
            />
          </el-input>
        </el-form-item>
        <el-form-item label="部门" prop="department_ids">
          <member-list-pane :key="timer1" v-model="inviteForm.department_ids" :data="dept_data" :tabs="['department']" modal-append-to-body />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onInviteUserSubmit">邀请</el-button>
          <el-button @click="inviteUserDialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog class="pub_dialog" :visible.sync="deptSelectDialogVisible" title="部门列表" width="60%">
      <member-list
        v-if="deptSelectDialogVisible" v-model="selectedMember" :tabs="['department']"
        @cancel="deptSelectDialogVisible=false" @input="onAdjustDept"
      />
    </el-dialog>
    <el-drawer
      :wrapper-closable="false"
      title="用户编辑"
      :visible.sync="drawerVisible"
      direction="rtl"
      :before-close="handleDrawerClose"
    >
      <div class="mx-2">
        <el-form ref="userForm" :model="userForm" :rules="userFormRules">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="userForm.username" />
          </el-form-item>
          <el-form-item label="昵称" prop="nickname">
            <el-input v-model="userForm.nickname" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="userForm.password" placeholder="留空为不修改" />
          </el-form-item>
          <el-button type="primary" @click="handleUpdateUser">更新</el-button>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import axios from 'axios'
import zroute from '@/ziggy'
import Draggable from 'vuedraggable'
import {formatToTree} from '@/utils'
import MemberList from '../../components/MemberList'
import MemberListPane from '../../components/MemberListPane'

export default {
  components: {
    MemberListPane,
    MemberList,
    Draggable,
  },
  layout: Layout,
  props: {
    roles: {
      type: Array,
      default: () => [],
    },
    departments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      timer1: Date.now(),
      drawerVisible: false,
      selectedDepartment: [],
      showPassword: false,
      deptSelectDialogVisible: false,
      inviteUserDialogVisible: false,
      selectedMember: [],
      checkedRow: [],
      addUserDialogVisible: false,
      name: '',
      // formatDepartments: [],
      role_lists: this.roles,
      addRoleDialogVisible: false,
      addDeptDialogVisible: false,
      activeName: 'department',
      addRoleFormRules: {
        name: [
          {required: true, message: '请输入角色名称', trigger: 'blur'},
        ],
      },
      addDeptFormRules: {
        name: [
          {required: true, message: '请输入部门名称', trigger: 'blur'},
        ],
      },
      tableData: [],
      addRoleForm: {
        name: '',
        parent_id: 0,
      },
      addDeptForm: {
        name: '',
      },
      editRoleForm: {
        name: '',
        id: 0,
      },
      editDeptForm: {
        name: '',
        id: 0,
      },
      inviteForm: {
        username: '',
        nickname: '',
        password: '',
        department_ids: [],
      },
      dept_data: [],
      userForm: {
        username: '',
        id: 0,
        nickname: '',
        password: '',
      },
      userFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
        ],
        password: [
          { min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur' },
        ],
      },
      inviteFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur' },
        ],
        department_ids: [
          { required: true, message: '请选择部门', trigger: 'blur' },
        ],
      },
      total: 0,
      listMemberQuery: {
        role_id: 0,
        page: 1,
        per_page: 20,
        type: 'department',
        department_id: 0,
      },
    }
  },
  computed: {
    formatDepartments() {
      return formatToTree(this.departments)
    },
  },
  watch: {
    roles: {
      handler(val) {
        this.role_lists = val
      },
      deep: true,
    },
    // listMemberQuery: {
    //   handler() {
    //     this.getListMember()
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.handleDepartmentSelect(this.departments[0])
  },
  methods: {
    onAdminSwitch(val, id) {
      console.log('onAdminSwitch', val, id)
      axios.post(zroute('contacts.admin.set'), {deptId: this.listMemberQuery.department_id, admin: val ? id : 0}).then(res => {
        if (res.data.code === 0) {
          this.$message.error(res.data.msg)
        } else {
          this.drawerVisible = false
          this.$message.success('修改成功')
          this.getListMember()
        }
      })
    },
    handleUpdateUser() {
      this.$refs['userForm'].validate(valid => {
        if (valid) {
          axios.post(zroute('contacts.user.update'), this.userForm).then(res => {
            if (res.data.code === 0) {
              this.$message.error(res.data.msg)
            } else {
              this.drawerVisible = false
              this.$message.success('修改成功')
              this.getListMember()
            }
          })
        }
      })
    },
    onCellClick(row) {
      console.log('onCellClick', row)
      this.userForm = {
        id: row.id,
        username: row.username,
        nickname: row.nickname,
        password: '',
      }
      this.drawerVisible=true
    },
    handleDrawerClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleSizeChange(val) {
      this.listMemberQuery.per_page = val
      this.getListMember()

    },
    handleCurrentChange(val) {
      this.listMemberQuery.page = val
      this.getListMember()

    },
    handleAllMemberSelect() {
      this.listMemberQuery.department_id = 0
      this.listMemberQuery.page = 1
      this.getListMember()
    },
    onAdjustDept() {
      if (this.checkedRow.length === 0) {
        this.$message.error('请选择要调整部门的用户')
        return
      }
      this.deptSelectDialogVisible = false
      console.log('onAdjustDept', this.selectedMember, this.checkedRow)
      axios.post(zroute('contacts.adjust.department'), {
        user_ids: this.checkedRow.map(item => item.id),
        department_ids: this.selectedMember.map(item => item.id),
      }).then(res => {
        this.getListMember()
      })
    },
    onAddDept() {
      console.log('onAddDept', this.selectedMember)
      this.selectedDepartment = this.selectedMember
      this.inviteForm.department_ids = this.selectedDepartment.map(item => item.key)
      this.deptSelectDialogVisible = false
    },
    togglePasswordStyle() {
      this.showPassword = !this.showPassword
    },
    onInviteUserSubmit() {
      this.$refs['inviteForm'].validate(valid => {
        if (valid) {
          console.log('invite user')
          axios.post(zroute('contacts.invite.user'), this.inviteForm).then(res => {
            if (res.data.code === 0) {
              this.$message.error(res.data.msg)
            } else {
              this.inviteUserDialogVisible = false
              this.getListMember()
              this.$message.success('邀请成功')
            }

          })
        }
      })

    },
    handleInviteUser() {
      this.inviteForm =  {
        username: '',
        nickname: '',
        password: '',
        department_ids: this.listMemberQuery.department_id > 0 ? ['department_'+this.listMemberQuery.department_id] : [],
      }
      if (this.listMemberQuery.department_id > 0) {
        this.dept_data = [{id: this.listMemberQuery.department_id, type: 'department', name: this.name}]
      }
      this.timer1 = Date.now()
      this.inviteUserDialogVisible = true
    },
    handleAddRoleMember() {
      this.addUserDialogVisible = true
      this.selectedMember = []
    },
    handleSelectionChange(val) {
      this.checkedRow = val
      // console.log('handleSelectionChange', val)
    },
    handleRemoveRoleMember() {
      if (this.checkedRow.length === 0) {
        this.$message.error('请选择要删除的成员')
        return
      }
      axios.post(zroute('contacts.role.member.remove'), {
        role_id: this.listMemberQuery.role_id,
        user_ids: this.checkedRow.map(item => item.id),
      }).then(() => {
        this.$message({
          type: 'success',
          message: '移出成功',
        })
        this.getListMember()
      })
    },
    handleAddRoleMemberSubmit() {
      if (this.selectedMember.length === 0) {
        this.$message.error('请选择要添加的成员')
        return
      }
      // this.addUserDialogVisible = false
      console.log('handleAddRoleMemberSubmit', this.selectedMember)
      axios.post(zroute('contacts.role.member.add'), {
        role_id: this.listMemberQuery.role_id,
        user_ids: this.selectedMember.filter(item => item.type === 'user').map(item => item.id),
      }).then((res) => {
        if (res.data.code === 0) {
          this.$message.error(res.data.msg)
        } else {
          this.addUserDialogVisible = false
          this.$message({
            type: 'success',
            message: '添加成功',
          })
          this.getListMember()
        }

      })
    },
    getListMember() {
      if (this.listMemberQuery.role_id === 0 && this.listMemberQuery.type === 'role') {
        return
      }
      axios.get(zroute('contacts.list'), {
        params: this.listMemberQuery,
      }).then(res => {
        this.tableData = res.data.members.list
        this.total = res.data.members.total
      })
    },
    handleDeptMoreMenuSelect(key) {
      console.log('handleDeptMoreMenuSelect', key)
      if (key.action === 'edit') {
        this.handleEditDeptName(key.dept)
      } else if (key.action === 'add') {
        this.handleAddDept(key.dept.id)
      } else if (key.action === 'delete') {
        this.handleDeleteDept(key.dept)
      }
    },
    handleDepartmentSelect(data) {
      console.log('department select', data, this.formatDepartments)
      this.listMemberQuery.department_id = data.id
      this.name = data.name
      this.listMemberQuery.page = 1
      this.getListMember()
    },
    handleMoveEnd(evt) {
      console.log('end', evt, this.role_lists)
      // loop through the roles and update the order
      var orders = []
      this.role_lists.forEach((role) => {
        orders.push(role.id)
      })
      axios.post(zroute('contacts.role.sort'), {
        orders: orders,
      }).then(() => {
      })
    },
    handleMoreMenuSelect(key) {
      console.log('handleMoreMenuSelect', key)
      if (key.action === 'edit') {
        this.handleEditRoleName(key.role)
      } else if (key.action === 'delete') {
        this.$confirm('是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          axios.post(zroute('contacts.role.delete'), {id: key.role.id}).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.role_lists.splice(this.role_lists.indexOf(key.role), 1)
            // this.roles[index].name = this.editRoleForm.name
            // this.roles[index].visible = false
          })
        })
      }
    },
    handldEditDeptSubmit(ref, data) {
      this.$refs[ref].validate(valid => {
        if (valid) {
          axios.post(zroute('contacts.dept.edit'), this.editDeptForm).then(() => {
            this.$message({
              type: 'success',
              message: '编辑成功',
            })
            data.visible = false
            data.name = this.editDeptForm.name
            // this.role_lists[index].name = this.editDeptForm.name
            // this.role_lists[index].visible = false
          })
        }
      })
    },
    handldEditRoleSubmit(ref, index) {
      this.$refs[ref][index].validate(valid => {
        if (valid) {
          axios.post(zroute('contacts.role.edit'), this.editRoleForm).then(() => {
            this.$message({
              type: 'success',
              message: '编辑成功',
            })
            this.role_lists[index].name = this.editRoleForm.name
            this.role_lists[index].visible = false
          })
        }
      })
    },
    handleEditDeptName(dept) {
      console.log('handleEditDeptName', dept)
      this.editDeptForm.name = dept.name
      this.editDeptForm.id = dept.id
      dept.visible = true
    },
    handleEditRoleName(role) {
      console.log('handleEditRoleName', role)
      this.role_lists.forEach((item) => {
        item.visible = false
      })
      this.editRoleForm.name = role.name
      this.editRoleForm.id = role.id
      role.visible = true
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.listMemberQuery.role_id = key
      console.log('handleSelect', this.roles)
      this.name = this.roles.find((item) => {
        return item.id == key
      }).name
      this.listMemberQuery.page = 1
      this.getListMember()
    },
    handleClick(tab, event) {
      console.log(tab, event, this.activeName)
      if (this.activeName !== this.listMemberQuery.type) {
        this.tableData = []
        this.listMemberQuery.type = this.activeName
        this.listMemberQuery.page = 1
        this.getListMember()
      }
    },
    handleAddRole() {
      this.addRoleDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addRoleForm.resetFields()
      })
    },
    handleAddDept(parent_id) {
      this.addDeptDialogVisible = true
      this.addDeptForm.parent_id = parent_id
      this.$nextTick(() => {
        this.$refs.addDeptForm.resetFields()
      })
    },
    handleAddRoleSubmit() {
      console.log()
      this.$refs.addRoleForm.validate(valid => {
        if (valid) {
          axios.post(zroute('contacts.role.add'), this.addRoleForm).then(response => {
            this.addRoleDialogVisible = false
            this.$refs.addRoleForm.resetFields()
            this.$inertia.reload({only: ['roles']})
            // this.$router.push({name: 'contacts.roles.index'})
          })
          // this.$inertia.post(route('admin.roles.store'), this.addRoleForm)
        }
      })
    },
    handleAddDeptSubmit() {
      this.$refs.addDeptForm.validate(valid => {
        if (valid) {
          axios.post(zroute('contacts.dept.add'), this.addDeptForm).then(response => {
            this.addDeptDialogVisible = false
            this.$refs.addDeptForm.resetFields()
            this.$inertia.reload({ only: ['departments'] })
            // this.$router.push({name: 'contacts.roles.index'})
          })
          // this.$inertia.post(route('admin.roles.store'), this.addRoleForm)
        }
      })
    },
    openAdjustDialog() {
      if (this.checkedRow.length === 0) {
        this.$message.error('请选择要调整部门的用户')
        return
      }
      this.selectedMember = []
      this.deptSelectDialogVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.el-tag {
  margin-left: 5px;
  margin-top: 5px;
}

.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.el-tabs--card {
  height: calc(100vh - 110px);
}

.el-tabs-pane {
  height: calc(100vh - 110px);
  overflow-y: auto;
}

.role-btn {
  .el-button {
    margin: 0;
    padding: 0;
    width: 25px;
  }
}

::v-deep .dept_tree {
  .el-tree-node__content {
    font-size: 14px;
    height: 40px;
  }
}

::v-deep .dept_tree.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #409EFF
}

.member {
  .el-header {
    line-height: 40px;
    background-color: #fff;
  }
}

.menu-type {
  height: 28px;
  padding-left: 15px;
  color: #91a1b7;
  font-size: 14px;
  line-height: 28px;
}

.el-menu-item {
  height: 40px;
  line-height: 40px;
}

</style>
